import CleaningBarChart from "./cleaning-bar-chart";
import CleaningPieChart from "./cleaning-pie-chart";
import SelectCard from "./select-card";
import { ClientCleaningModel } from "./types";

const ChartSection = ({
  selectedClient,
  view,
  mutate,
}: {
  selectedClient: ClientCleaningModel | undefined;
  view: "pie" | "bar";
  mutate: () => void;
}) => {
  const chartMap = {
    pie: CleaningPieChart,
    bar: CleaningBarChart,
  };
  const ChartComponent = chartMap[view];

  return (
    <>
      {selectedClient && (
        <SelectCard
          selectedClient={selectedClient}
          mutate={mutate}
          dataLength={selectedClient?.entityData.length}
        />
      )}

      <ChartComponent entityData={selectedClient?.entityData || []} />
    </>
  );
};
export default ChartSection;
